import { render, staticRenderFns } from "./RadarChartJS.vue?vue&type=template&id=ab449d74&"
import script from "./RadarChartJS.vue?vue&type=script&lang=ts&"
export * from "./RadarChartJS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports